{
  "name": "@ns/support-hmrc-vat-name-review",
  "version": "1.0.0",
  "description": "A company's VAT registration name differs from its Companies House name: approve or reject the VAT number through hmrc/vat-name-review",
  "inputs": {
    "subjectCompanyId": {
      "type": "string"
    },
    "subjectCompanyName": {
      "type": "string"
    },
    "validationJobId": {
      "type": "string"
    }
  },
  "outcomes": {
    "approved": {},
    "rejected": {}
  }
}
